import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, path = '', image, type = 'website', noIndex = false, jsonLd, article }) => {
  const siteName = 'Sandend House';
  const baseUrl = 'https://theknox.co.uk';
  const defaultDescription = 'Sandend House is the first-generation private family office founded by Calum Knox, building and stewarding businesses, intellectual property and long-term assets.';
  const defaultImage = `${baseUrl}/og-image.jpg`;

  const fullTitle = title || `${siteName} | The Knox Family Office`;
  const fullUrl = `${baseUrl}${path}`;
  const metaDescription = description || defaultDescription;
  const ogImage = image || defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noIndex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />}

      <meta property="og:type" content={article ? 'article' : type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Sandend House | The Knox Family Office" />
      <meta property="og:locale" content="en_GB" />

      {article && article.author && <meta property="article:author" content={article.author} />}
      {article && article.publishedTime && <meta property="article:published_time" content={article.publishedTime} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      <link rel="canonical" href={fullUrl} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
